import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import {Ng2Webstorage} from 'ngx-webstorage';

// Angular Google Maps (AGM)
// import { AgmCoreModule } from "@agm/core";

import { ThemeComponent } from './theme/theme.component';
import { ThemeBlankComponent } from './theme/theme-blank.component';
import { LayoutModule } from './theme/layouts/layout.module';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ScriptLoaderService } from "./_services/script-loader.service";
import { ThemeRoutingModule } from "./theme/theme-routing.module";
// import { AuthModule } from "./auth/auth.module";
import { ApiService } from "./api/api.service";
import { JwtService } from "./api/jwt.service";

@NgModule({
  declarations: [
    ThemeComponent,
    ThemeBlankComponent,
    AppComponent,
  ],
  imports: [
    LayoutModule,
    BrowserModule,
    Ng2Webstorage,
    BrowserAnimationsModule,
    AppRoutingModule,
    ThemeRoutingModule,
    // AuthModule,
    // AgmCoreModule.forRoot({
    //   apiKey : 'AIzaSyDD487tMsK1NY_IELi72gjr6V4537-MS_k'
    // })
    Ng2Webstorage,
    // BrowserModule.withServerTransition({appId: 'ang4-seo-pre'}),
    BrowserModule,
        FormsModule,    
        HttpModule


  ],
  providers: [
    ApiService,
    JwtService,
    ScriptLoaderService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts